module.exports = __webpack_public_path__ + "img/CLOAK-alt.4a140803.svg";